import React, { lazy } from 'react';

const Settings = lazy(() =>
  import('./Settings/Settings').then(module => ({
    default: module.Settings,
  })),
);

const projectXRoutes = [
  {
    props: {
      exact: true,
      path: `/general-settings`,
    },
    component: <Settings />,
  },
];

export default projectXRoutes;
